import { Link, useLocation } from "react-router-dom";
import { Compass, Home } from "lucide-react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-md w-full text-center rounded-2xl border border-border bg-card p-8 shadow-card">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Compass className="h-6 w-6" />
          </div>
          <h1 className="text-3xl font-bold text-foreground">404</h1>
          <p className="mt-2 text-lg text-foreground">This page doesn't exist.</p>
          <p className="mt-1 text-sm text-muted-foreground break-all">
            <code>{location.pathname}</code>
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2">
            <Button asChild>
              <Link to="/"><Home className="h-4 w-4" /> Home</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/programs">Browse programs</Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
